import { useState } from 'react'

const checkDefined = (obj) => (prop) => typeof obj[prop] !== undefined

const useInputValue = (initialValue) => {
    const [value, setValue] = useState(initialValue)
    return {
        value,
        onChange: (e) => {
            console.log({ e })
            let value
            if (typeof e === 'string') {
                value = e
            }
            if (checkDefined(e)('id')) {
                value = e.id
            } else if (checkDefined(e)('value')) {
                value = e.value
            } else {
                value = e.target.value || e.target.innerText
            }
            setValue(value)
        },
    }
}

export default useInputValue
